import { type FC } from "preact/compat";
import { KeenSliderComponent } from "@components/KeenSlider";
import "./index.scss";
import Icons from "@components/icons";

interface SlideType {
  imageObject?: {
    src: string;
    alt: string;
    width: number;
  };
  quote: string;
  attributed: string;
}

interface SliderProps {
  id: string;
  slides: SlideType[];
}

export const Slider: FC<SliderProps> = ({ id, slides }) => {
  slides = [...slides, ...slides];

  return (
    <div className="quote-carousel-display">
      <KeenSliderComponent
        className="quote-carousel-display__container"
        options={{
          mode: "free",
          loop: true,
          autoplay: {
            enabled: true,
            duration: slides.length * 10,
            distance: slides.length,
            pauseOnHover: true,
          },
          slides: {
            perView: "auto",
            spacing: 15,
          },
          breakpoints: {
            1024: {
              slides: {
                spacing: 17,
              },
            },
          },
        }}
      >
        {slides.map((slide, index) => (
          <div key={index} className="quote-carousel-display__slide keen-slider__slide">
            <blockquote className="quote-carousel-display__slide-quote">
              <p className="quote-carousel-display__slide-quote-text text-2xl md:text-[2rem]">
                {slide.quote}
              </p>
            </blockquote>
            {slide.imageObject && (
              <div className="quote-carousel-display__slide-image-container">
                <img
                  className="quote-carousel-display__slide-image"
                  src={slide.imageObject.src}
                  alt={slide.imageObject.alt}
                  width={slide.imageObject.width}
                />
                <cite className="quote-carousel-display__slide-quote-attributed">
                  {slide.attributed}
                </cite>
              </div>
            )}
          </div>
        ))}
      </KeenSliderComponent>
    </div>
  );
};
